import React from 'react';
import { Button } from './ui/Button';
export function CTABanner() {
  const scrollToQuote = () => {
    document.getElementById('quote')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative py-24 md:py-32 bg-accent overflow-hidden" data-id="element-10">
      {/* Subtle Texture Overlay */}
      <div className="absolute inset-0 opacity-10 mix-blend-overlay pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    }} data-id="element-11" />

      <div className="container relative z-10 mx-auto px-4 md:px-6 text-center" data-id="element-12">
        <h2 className="font-heading text-4xl md:text-6xl font-bold text-white mb-6 uppercase tracking-tight" data-id="element-13">
          Ready for a Cleaner Property?
        </h2>
        <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-2xl mx-auto font-medium" data-id="element-14">
          Get a free quote in minutes. No pressure.
        </p>
        <Button onClick={scrollToQuote} size="lg" className="bg-primary hover:bg-primary/90 text-white font-bold text-lg h-16 px-10 w-full sm:w-auto shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1" data-id="element-15">
          Book Your Free Quote
        </Button>
      </div>
    </section>;
}